export const TABS = {
	information: 0,
	activeOrders: 1,
	ordersHistory: 2,
	internalSchedules: 3,
	crossBorderSchedules: 4,
}
